export const APP_VERSION = "20260710-2";

export const shouldReloadForVersion = (
  currentVersion: string,
  deployedVersion: string | null | undefined
): boolean => Boolean(deployedVersion && deployedVersion !== currentVersion);

export const reloadWhenVersionChanges = async (): Promise<void> => {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return;

    const data = await response.json();
    if (shouldReloadForVersion(APP_VERSION, data?.version)) {
      window.location.reload();
    }
  } catch {
    // Version checks must not interrupt normal app usage when offline.
  }
};
